import React, { useCallback, useContext, useRef, useState } from "react";
import Webcam from "react-webcam";
import { SelectedImageContext } from "../../../SelectedImageContext";
import { iconsImgs } from "../../../utils/icons";
import { base64StringtoFile } from "../Base64Image/ConvertBase64ToFile";
import { CameraContext } from "../../../CameraContext";

interface CamCropImageProps {
    SetShowCropModal?: (val: boolean) => void;
    uploadImgAfterCapture?: boolean;
    setShowImgModal?: (val: boolean) => void;
    isFriendProfilePicture?: boolean
    isOpen?: boolean;
    setIsOpen?: (value: boolean) => void;
    onCapture?: (file: File) => void;
}

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
    facingMode: FACING_MODE_USER
};

const WebcamCapture: React.FC<CamCropImageProps> = ({
    SetShowCropModal,
    uploadImgAfterCapture,
    setShowImgModal,
    isFriendProfilePicture,
    isOpen,
    setIsOpen,
    onCapture,
}) => {

    const webcamRef = useRef<Webcam>(null);
    const [facingMode, setFacingMode] = useState(FACING_MODE_USER);

    const { setSelectedImageFile, setAttachmentFile, setSelectedFriendImg } = useContext(SelectedImageContext);
    const cameraContext = useContext(CameraContext);
    const cameraIsOpen = isOpen ?? cameraContext.isOpen;
    const setCameraOpen = setIsOpen ?? cameraContext.setOpenCamera;



    const capture = useCallback(() => {

        const imageSrc = webcamRef.current?.getScreenshot();
        const file = base64StringtoFile(imageSrc, "CamCapture");

        if (file && onCapture) {
            setCameraOpen(false);
            onCapture(file);
            return;
        }

        if (isFriendProfilePicture && !uploadImgAfterCapture) {
            
            if (file && setShowImgModal) {
                setCameraOpen(false);
                setSelectedFriendImg(file);
                setShowImgModal(true);
            }

        } else if (uploadImgAfterCapture && !isFriendProfilePicture) {

            if (file && setShowImgModal) {
                setCameraOpen(false);
                setAttachmentFile(file);
                setShowImgModal(true);
            }

        } else {

            if (file)
                setSelectedImageFile(file)

            SetShowCropModal?.(true); // Opening Crop modal.
            setCameraOpen(false);
        }

    }, [webcamRef, isFriendProfilePicture, uploadImgAfterCapture, setShowImgModal, onCapture, setCameraOpen, setSelectedFriendImg, setAttachmentFile, SetShowCropModal, setSelectedImageFile]);

    const handleCameraSwitch = React.useCallback(() => {
        setFacingMode(
            prevState =>
                prevState === FACING_MODE_USER
                    ? FACING_MODE_ENVIRONMENT
                    : FACING_MODE_USER
        );
    }, []);

    const stopCamera = () => {
        setCameraOpen(false);
    };

    return (
        <>
            {cameraIsOpen &&
                <div className="camera-container">
                    <div className="camera">
                        <Webcam
                            audio={false}
                            videoConstraints={{
                                ...videoConstraints,
                                facingMode
                            }}
                            ref={webcamRef}
                            className="desktopUI"
                        />
                    </div>
                    <div className="button-container">
                        <span className="Cambutton" onClick={stopCamera}>
                            <img src={iconsImgs.CloseCamera} className="image-size" alt="StopCamera" />
                        </span>
                        <span className="Cambutton" onClick={capture}>
                            <img src={iconsImgs.Camera} className="image-Size" alt="Capture" />
                        </span>
                        <span className="Cambutton" onClick={handleCameraSwitch}>
                            <img src={iconsImgs.SwitchCamera} className="image-size" alt="SwitchCamera" />
                        </span>
                    </div>
                </div>
            }
        </>
    );
};

export default WebcamCapture;
